import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigLeftDash: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M19 15V9' }],
    ['path', { d: 'M15 15h-3v4l-7-7 7-7v4h3v6z' }],
  ],
];

export default ArrowBigLeftDash;
